import { useEffect, useState } from "react";
import config from "config";
import { setSocialLoginStatus } from "lib/authHelper";
import facebook from "lib/facebook";
import google from "lib/google";
import providers from "lib/providers";
import twitter from "lib/twitter";

function useController(onClose: () => void) {
  const [isLoading, setIsLoading] = useState(false);

  const googleLogin = async (promise: Promise<{ code: string }>) => {
    try {
      const token = await promise;
      setSocialLoginStatus(true);
      setIsLoading(true);
      await providers.LoginProvider.googleLogin({
        data: { role: config.userJoinRole, token: token.code },
      });
      onClose();
    } catch (e) {
      setSocialLoginStatus(false);
      setIsLoading(false);
      throw e;
    }
  };

  const twLogin = () => {
    twitter
      .login()
      .then(async (response) => {
        if (response) {
          setSocialLoginStatus(true);
          setIsLoading(true);
          await providers.LoginProvider.twitterLogin({
            data: { ...response, role: config.userJoinRole },
          });
          onClose();
        }
      })
      .catch((e) => {
        setSocialLoginStatus(false);
        setIsLoading(false);
        throw e;
      });
  };

  const fbLogin = () => {
    facebook
      .login()
      .then(async (token) => {
        if (!token || !token.authResponse) return;
        setSocialLoginStatus(true);
        setIsLoading(true);
        await providers.LoginProvider.facebookLogin({
          data: { role: config.userJoinRole, token: token.authResponse.accessToken },
        });
        onClose();
      })
      .catch((e) => {
        setSocialLoginStatus(false);
        setIsLoading(false);
        throw e;
      });
  };

  useEffect(() => {
    if (!config.auth.google) return;
    googleLogin(google.login("google_btn"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    twLogin,
    fbLogin,
    isLoading,
  };
}

export default useController;
